import {v4 as uuid} from 'uuid';
import {Constants} from '../../constants';
import {CookieService} from 'ngx-cookie-service';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConversationId {
    /**
     * Conversation ID cookie name
     * @var {string}
     */
    private _conversationIdCookieName: string = Constants.COOKIE_CONVERSATION_ID;

    /**
     * Class constructor
     *
     * @param _cookieService
     */
    public constructor(
        private _cookieService: CookieService
    ) {
        this._checkAndSetConversationIdCookie();
    }

    /**
     * Gets the conversation ID from a cookie
     *
     * @returns {string}
     */
    public getConversationId(): string {
        return this._cookieService.get(this._conversationIdCookieName);
    }

    /**
     * Checks if conversation ID cookie is present and sets it if not
     *
     * @private
     * @returns {void}
     */
    private _checkAndSetConversationIdCookie(): void {
        if (!this._cookieService.check(this._conversationIdCookieName)) {
            this._cookieService.set(
                this._conversationIdCookieName,
                uuid()
            );
        }
    }
}
